<template lang="html">
	<div :class="'text item spot' + (isSelected ? ' selected': '')">
		<a @click.prevent="spotSelectedHandler(spot)" class="small-title">{{ spot.name }}</a>
		<p>{{ spot.address }}</p>
		<div class="rating">
			<el-rate v-model="spot.rating / 20"></el-rate>
		</div>
		<SpotItemDirectives :spot="spot"/>
	</div>
</template>
<script>
import SpotItemDirectives from '@/components/SpotItemDirectives.vue';
export default {
	name: 'SpotListItem',
	props: {
		spot: Object,
		spotSelectedHandler: Function,
		isSelected: {
			type: Boolean,
			default: false
		}
	},
	components: {
		SpotItemDirectives
	}
}
</script>
<style lang="scss" scoped>
.spot {
	&.selected {
		.small-title {
			color: #f00;
		}
	}
	border-bottom: 1px solid #eee;
	margin-bottom:1em;
	.small-title {
		font-size:16px;
		font-weight:600;
		margin-bottom:1.5em;
	}
	a {
		cursor: pointer;
	}
	p {
		font-size: 0.85em;
		margin:0.6em 0;
		line-height:1.5em;
		color: #777;
	}
}
.rating {
	width:100%;
	margin: 0.5em 0;
}
</style>